







import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
const namespace: string = 'counter';
import AudienceDetailsEditor from '@/components/AudienceDetailsEditor.vue';
import BaseView from '../BaseView';
import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceDetailsService } from '../services/AudienceDetailsService';

@Component({
    components: {
        AudienceDetailsEditor
    },
})
export default class CreateAudience extends BaseView {

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private audienceDetails: AudienceDetails;
    private audienceService!: AudienceDetailsService;

    constructor() {
        super();
        this.audienceDetails = new AudienceDetails();
    }

    private mounted() {
        // We have to wait until the VueX has been initialized before we can initialize the service
        this.audienceService = new AudienceDetailsService(this.clientId);
    }

    private handleSave(formData: AudienceDetails) {
        this
            .audienceService
            .SaveAudience(formData, false)
            .then((response) => {
                console.log(response);

                if (!this.checkValidationResult(response)) {
                    return;
                }

                this.successToastPopup('Audience saved successfully.');
                const returnURL = encodeURI('/');
                this.$router.push(`/audience/${response.data.data.audienceID}/edit/${response.data.data.audienceDetailId}?returnURL=${returnURL}`);
                this.refreshTags();
            })
            .catch((xhr) => {
                console.log('CreateAudience => Save => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save';
                if (payload) {
                    validationErrors = '';
                    for (const i in payload) {
                        if (payload.hasOwnProperty(i)) {
                            validationErrors += `${payload[i][0]} \n`;
                        }
                    }
                }
                this.dangerToastPopup(validationErrors);
            })
            .then(() => {
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.unblockSaving();
            });
    }

    private refreshTags() {
        this.$store.dispatch('tag/initializeClient', this.clientId);
    }

    private handleSavePublish(formData: AudienceDetails) {
        this
            .audienceService
            .SaveAudience(formData, true)
            .then((response) => {
                console.log(response);

                if (!this.checkValidationResult(response)) {
                    return;
                }

                this.successToastPopup('Audience published successfully.');
                const returnURL = encodeURI('/');
                this.$router.push(`/audience/${response.data.data.audienceID}/edit/${response.data.data.audienceDetailId}?return=${returnURL}`);
                this.refreshTags();

                // start new counts generation
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.forceStatisticsGeneration(response.data.data.audienceDetailId);
            })
            .catch((xhr) => {
                console.log('CreateAudience => SavePublish => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save and Publish';
                if (payload) {
                    validationErrors = '';
                    for (const i in payload) {
                        if (payload.hasOwnProperty(i)) {
                            validationErrors += `${payload[i][0]} \n`;
                        }
                    }
                }
                this.dangerToastPopup(validationErrors);
            })
            .then(() => {
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.unblockSaving();
            });
    }

    private checkValidationResult(response: any): boolean {
        if (response.data.data.validationResult !== 0) {
            //switch (response.data.data.validationResult) {
            //    case 1: // DuplicatedName
            //        this.warningToastPopup('Audience with this name already exists.');
            //        return false;
            //    default:
            //        return false; 
            //}
            return false;
        }

        return true;
    }
}
